import {sounds} from "./sound"

export const SoundsMiddlewareMap = {
    1041: function () {
        return sounds.zombie()
    }, //Gabby
    1049: function () {
        return sounds.spark_summon()
    }, //fire e
    1059: function () {
        return sounds.healing()
    }, // earth e
    1053: function () {
        return sounds.shock_damage()
    }, // air e

    1048: function () {
        return sounds.dark_damage()
    }, // Zombie W
    1159: function () {
        return sounds.dark_damage()
    }, // High Cultist
    1160: function () {
        return sounds.dark_damage()
    }, // Fanatic
    1161: function () {
        return sounds.horde_drums()
    }, // Champion
    1162: function () {
        return sounds.totem()
    }, // Totem
    1038: function () {
        return sounds.healing()
    }, // Cat girl
    1080: function () {
        return sounds.battle_play_air_mana()
    }, // Air Witch
    1081: function () {
        return sounds.battle_play_earth_mana()
    }, // Earth Witch
    1082: function () {
        return sounds.battle_play_fire_mana()
    }, // Fire Witch
    1084: function () {
        return sounds.healing_potion()
    }, // Alice, Demon Hunter
    1085: function () {
        return sounds.dark_damage()
    }, // Demon Princess
    1089: function () {
        return sounds.uin_stun()
    }, //Uin
    1095: function () {
        return sounds.jul_chain()
    }, //Jul troll queen
    1111: function () {
        return sounds.navigator()
    },
    1112: function () {
        return sounds.doctor()
    },
    1114: function () {
        return sounds.gunner()
    },
    1124: function () {
        return sounds.buccaneer()
    },
    1129: function () {
        return sounds.stone_golem_summon()
    },
    1130: function () {
        return sounds.wind_golem_summon()
    },
    1131: function () {
        return sounds.spark_golem_summon()
    },
    1136: function () {
        return sounds.move_water()
    },
    1137: function () {
        return sounds.slime()
    },
    1139: function () {
        return sounds.spear()
    },
    1157: function () {
        return sounds.slime_bubble()
    },


    // effect with no sound when enter or when die
    1149: function () {
        return sounds.cannon()
    },
    1146: function () {
        return sounds.call()
    },
    1143: function () {
        return sounds.lizard()
    },
    1142: function () {
        return sounds.seagul()
    },
    1141: function () {
        return sounds.claws()
    },
    1125: function () {
        return sounds.rat()
    },
    1135: function () {
        return sounds.teacher_draw()
    },
    1122: function () {
        return sounds.battle_play_air_mana()
    },
    1028: function () {
        return null
    },
    1096: function () {
        return null
    },
    1031: function () {
        return null
    },
    1056: function () {
        return null
    },
    1063: function () {
        return null
    },
    1057: function () {
        return null
    },
    1094: function () {
        return null
    },
    1040: function () {
        return null
    },
    1092: function () {
        return null
    },
    1105: function () {
        return null
    }
}
